import { RootElmActionReturnType, sendLocalAction } from 'actions/service/rootElmAction';

export interface FunctionTypes {
  assignBusinessServerToTables(serverId: number, tableIds: number[]): RootElmActionReturnType;
  cutServer(businessServerId: number): RootElmActionReturnType;
  unassignBusinessServerFromTable(tableId: number): RootElmActionReturnType;
}

export function assignBusinessServerToTables(businessServerId: number, tableIds: number[]) {
  return sendLocalAction('assignBusinessServerToTable', {
    businessServerId,
    tableId: tableIds,
  });
}

export function cutServer(businessServerId: number) {
  return sendLocalAction('cutServer', {
    id: businessServerId,
  });
}

export function unassignBusinessServerFromTable(tableId: number) {
  return sendLocalAction('removeServer', {
    tableIds: [tableId],
  });
}
